module.exports = __webpack_public_path__ + "backIcon.png?dd0baa69a69937600dc3bf035f3873c4";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vis/dist/img/network/backIcon.png
// module id = 565
// module chunks = 0